export var CameraMode;
(function (CameraMode) {
    CameraMode["STANDARD"] = "STANDARD";
    CameraMode["ORTHO"] = "ORTHO";
    CameraMode["TOP"] = "TOP";
    CameraMode["POV"] = "POV";
})(CameraMode || (CameraMode = {}));
